"use client";

import React from "react";
import { PencilRuler, ClipboardCheck, HardHat, ShieldCheck, Flame, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Progettazione (architettonica e strutturale)",
  description: "Sviluppiamo progetti tecnici per edifici e interventi edilizi, curando aspetti architettonici e strutturali e garantendo soluzioni funzionali, sicure e conformi alla normativa vigente.",
  icon: PencilRuler,
  link: "/ServicesPage"
}, {
  title: "Direzione lavori",
  description: "Seguiamo la realizzazione delle opere verificando la corretta esecuzione dei lavori, il rispetto del progetto, dei tempi e delle prescrizioni tecniche e normative.",
  icon: ClipboardCheck,
  link: "/ServicesPage"
}, {
  title: "Sicurezza nei cantieri (CSP/CSE – D.Lgs. 81/08 Titolo IV)",
  description: "Gestiamo la sicurezza nelle fasi di progettazione ed esecuzione dei lavori, redigendo la documentazione prevista e coordinando le imprese per prevenire rischi e infortuni in cantiere.",
  icon: HardHat,
  link: "/ServicesPage"
}, {
  title: "Consulenza sicurezza sul lavoro (D.Lgs. 81/08 – DVR, incarichi RSPP, ecc.)",
  description: "Supportiamo le aziende nella gestione degli obblighi in materia di salute e sicurezza sul lavoro, dalla valutazione dei rischi agli incarichi di RSPP, fino alla gestione della documentazione e delle procedure aziendali.",
  icon: ShieldCheck,
  link: "/ServicesPage"
}, {
  title: "Prevenzione incendi",
  description: "Assistiamo imprese e attività soggette ai controlli dei Vigili del Fuoco nella progettazione antincendio, nelle pratiche SCIA e nel rispetto delle norme di prevenzione incendi.",
  icon: Flame,
  link: "/ServicesPage"
}];
export default function SoluzioniDiSicurezzaEIngegneria() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="soluzioni-di-sicurezza-e-ingegneria" className="relative w-full bg-muted/30 py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03] dark:opacity-[0.05]" style={{
      backgroundImage: `linear-gradient(to right, var(--foreground) 1px, transparent 1px), linear-gradient(to bottom, var(--foreground) 1px, transparent 1px)`,
      backgroundSize: '40px 40px'
    }} aria-hidden="true" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div ref={headerRef} className={`max-w-3xl mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl font-bold text-primary tracking-tight mb-4">
            Soluzioni di Sicurezza e Ingegneria
          </h2>
          <p className="text-lg text-muted-foreground">
            Competenza tecnica e precisione industriale al servizio della tua azienda. 
            Interventi mirati per garantire conformità normativa e operatività sicura.
          </p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 transition-all duration-1000 delay-200 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {services.map((service, index) => {
          const Icon = service.icon;
          return <Link key={index} to={service.link} className="block group h-full outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background" data-index={index}>
                <Card className="h-full flex flex-col rounded-none border-border/60 bg-background/80 backdrop-blur-sm transition-all duration-300 group-hover:border-accent group-hover:shadow-lg group-hover:-translate-y-1 relative overflow-hidden">
                  {}
                  <div className="absolute top-0 left-0 w-full h-[2px] bg-transparent group-hover:bg-accent transition-colors duration-300" />
                  
                  <CardHeader className="pb-4 relative">
                    <div className="absolute top-6 right-6 p-2 bg-muted/50 rounded-sm group-hover:bg-accent/10 transition-colors duration-300">
                      <Icon className="size-6 text-muted-foreground group-hover:text-accent transition-colors duration-300" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="text-xl font-semibold text-primary pr-12 leading-tight">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  
                  <CardContent className="flex-grow">
                    <p className="text-muted-foreground text-sm leading-relaxed">
                      {service.description}
                    </p>
                  </CardContent>
                  
                  <CardFooter className="pt-0 mt-auto">
                    <div className="flex items-center text-sm font-medium text-accent opacity-0 -translate-x-4 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 ease-out">
                      Scopri di più
                      <ArrowRight className="ml-2 size-4" />
                    </div>
                  </CardFooter>
                </Card>
              </Link>;
        })}
        </div>
      </div>
    </section>;
}